import { Alert } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../../MdmCardFormStore";
import { FnFocus, FormField } from "../../types/MdmCardFormTypes";
import { CardCheckbox } from "../CardCheckbox";
import { CardDate } from "../CardDate";
import { CardInput } from "../CardInput";
import { CardInputNumber } from "../CardInputNumber";
import { CardSelect } from "../CardSelect";

interface PropsFieldView {
  form: MdmCardFormStore;
  field: FormField;
  focusBk: (onFocus: FnFocus) => void;
}

export const FieldView: React.FC<PropsFieldView> = observer((props) => {
  const { form, field, focusBk } = props;
  const { component } = field.meta;
  switch (component.type) {
    case "Input":
      return (
        <CardInput
          field={field}
          form={form}
          component={component}
          focusBk={focusBk}
        />
      );
    case "InputNumber":
      return (
        <CardInputNumber
          form={form}
          field={field}
          component={component}
          focusBk={focusBk}
        />
      );
    case "Checkbox":
      return <CardCheckbox field={field} form={form} />;
    case "Select":
      return <CardSelect form={form} field={field} component={component} />;
    case "Date":
      return (
        <CardDate
          form={form}
          field={field}
          component={component}
          focusBk={focusBk}
        />
      );
    default:
      break;
  }
  return <Alert type="error" message={component.type} />;
});
